import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { BASE_SSR_SET_DATA } from 'rebook/apps/base/constants';
import { BOOKS_COUNTERS_SET_DATA } from 'rebook/apps/books/constants';


export function setHeaders(headers) {
  return (dispatch) => {
    dispatch(setData({
      headers,
    }));
  };
}

export function resetHeaders() {
  return (dispatch) => {
    dispatch(setData({
      headers: null,
    }));
  };
}

export function setQuery(query) {
  return (dispatch) => {
    dispatch(setData({
      query,
    }));
  };
}

export function autoLoginUser(token) {
  return async(dispatch) => {
    await fetchQuery('/api/account/auto-login/', { method: 'post', json: { token: token } })
      .then(({ resp }) => {
        const cookieList = resp.headers.getAll('set-cookie');
        dispatch(setData({ cookieList }));
      })
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to auto-login user due to error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              data,
              error,
            },
          });
        }
      );
  };
}

export function fetchBooksPerSubscriptionInfo() {
  return (dispatch) => {
    fetchQuery('/api/info/')
      .then(({ data }) => {
        dispatch({ type: BOOKS_COUNTERS_SET_DATA, payload: data });
      })
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to fetch books per subscription counters', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              data,
              error,
            },
          });
        }
      );
  };
}

export function setData(payload) {
  return {
    type: BASE_SSR_SET_DATA,
    payload,
  };
}
